import { CreditCardWirelessOutlineIcon } from './CreditCardWirelessOutlineIcon';

/**
 * author: Michael Richins
 * id 694399D0-1348-4EB0-BA34-ECD2FE4987C2
 * name credit-card-wireless-outline
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-wireless-outline.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const CreditCardContactlessIcon = CreditCardWirelessOutlineIcon;
export default CreditCardContactlessIcon